import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Textbox from '~/src/components/form-components/textbox/textbox';
import { selectLegalForm } from '~/src/redux/lead/lead.selectors';
import RegNumbersService from '~/src/services/reg-numbers.service';
import type { RegNumberInputProps } from '~/src/components/common-components/reg-number-input/reg-number-input.types';

export const RegNumberInput: FC<RegNumberInputProps> = ({
    externalValue,
    placeholder,
    label,
    name,
    regNumbersType,
    errorText,
    required,
    disabled,
    inputErrorRef,
    analyticsref,
    analyticsreferror,
    className,
}) => {
    const [localValue, setLocalValue] = useState('');
    const [isValid, setIsValid] = useState(false);
    const [errorReg, setErrorReg] = useState('');
    const legalForm = useSelector(selectLegalForm);

    const checkError = (value: string) => {
        const isValid = RegNumbersService.checkValidLength(regNumbersType, value || localValue, legalForm);
        setIsValid(isValid);
        isValid && setErrorReg('');
        !isValid && !disabled && setErrorReg(errorText);
    };

    const onValueChangeHandler = async (event: ChangeEvent<HTMLInputElement>) => {
        const value = (event.target.value).replace(/\D/g, '');
        setLocalValue(value);
        checkError(value);
    };

    const onClear = () => {
        setLocalValue('');
        checkError('');
    };

    const onBlurHandler = async () => {
        checkError(localValue);
    };

    useEffect(() => {
        disabled && setErrorReg('');
    }, [disabled]);

    useEffect(() => {
        setLocalValue('');
    }, [legalForm]);

    return (
        <Textbox
            value={localValue || externalValue}
            onValueChange={(event) => onValueChangeHandler(event)}
            label={label}
            name={name}
            isReadOnly={disabled || !!externalValue}
            required={required}
            validated={isValid}
            error={errorReg}
            onBlurHandler={onBlurHandler}
            onClear={onClear}
            placeholder={placeholder}
            maxLength={RegNumbersService.getMaxLength(legalForm, regNumbersType)}
            inputErrorRef={inputErrorRef}
            className={className}
            analyticsref={analyticsref}
            analyticsreferror={analyticsreferror}
        />
    );
};